import AnimPlan from "./Animation/AnimPlan";

const Plan = () => {
  return (
    <section className="page__plan plan">
      <h2 className="plan__title">
        Step by step <span className="title--line">plan</span>
      </h2>

      <AnimPlan />
    </section>
  );
};

export default Plan;
